<div class="settings-page">
  <!-- Hero -->
  <header class="settings-hero">
    <div class="settings-hero__inner">
      <div class="settings-hero__brand">
        <div class="settings-hero__icon" aria-hidden="true">
          <i class="pi pi-sliders-h"></i>
        </div>
        <div class="settings-hero__text">
          <span class="settings-hero__eyebrow">{{ 'SETTINGS.SUBTITLE' | translate }}</span>
          <h1 class="settings-hero__title">{{ 'SETTINGS.TITLE' | translate }}</h1>
        </div>
      </div>
      @if (isAdminOrPastor && iglesia.churchName) {
      <div class="settings-hero__meta">
        <span class="settings-chip">
          <i class="pi pi-building"></i>
          {{ iglesia.churchName }}
        </span>
        @if (iglesia.churchZone) {
        <span class="settings-chip settings-chip--muted">
          <i class="pi pi-map-marker"></i>
          {{ iglesia.churchZone }}
        </span>
        }
      </div>
      }
    </div>
  </header>

  @if (isAdminOrPastor) {
  <div class="settings-layout">

    <!-- Fila principal: organización + firma -->
    <div class="settings-layout__primary">
      <!-- Información de la iglesia -->
      <article class="settings-panel settings-panel--span-5">
        <header class="settings-panel__head">
          <div class="settings-panel__icon settings-panel__icon--brand">
            <i class="pi pi-building-columns"></i>
          </div>
          <div class="settings-panel__titles">
            <h2 class="settings-panel__title">{{ 'SETTINGS.CHURCH_INFO' | translate }}</h2>
            <p class="settings-panel__desc">{{ 'SETTINGS.READONLY_HINT' | translate }}</p>
          </div>
        </header>

        @if (iglesia) {
        <div class="settings-panel__body">
          <div class="church-profile">
            <div class="church-profile__identity">
              <div class="church-profile__avatar" aria-hidden="true">
                <i class="pi pi-building"></i>
              </div>
              <div class="church-profile__identity-text">
                <h3 class="church-profile__name">{{ iglesia.churchName || '—' }}</h3>
                @if (iglesia.churchZone) {
                <span class="church-profile__badge">
                  <i class="pi pi-map-marker"></i>
                  {{ iglesia.churchZone }}
                </span>
                }
              </div>
            </div>

            <dl class="church-data">
              <div class="church-data__row church-data__row--full">
                <dt class="church-data__label">
                  <i class="pi pi-home"></i>
                  {{ 'SETTINGS.ADDRESS' | translate }}
                </dt>
                <dd class="church-data__value">{{ iglesia.churchAddress || '—' }}</dd>
              </div>
            </dl>

            <div class="settings-divider">
              <span>{{ 'SETTINGS.SECTION_PASTOR' | translate }}</span>
            </div>

            <div class="church-pastor">
              <div class="church-pastor__avatar" aria-hidden="true">
                <i class="pi pi-user"></i>
              </div>
              <div class="church-pastor__details">
                <span class="church-pastor__role">{{ 'SETTINGS.PASTOR_NAME' | translate }}</span>
                <p class="church-pastor__name">{{ iglesia.pastorName || '—' }}</p>

                <ul class="church-pastor__contacts">
                  <li class="church-pastor__contact">
                    <span class="church-pastor__contact-label">
                      <i class="pi pi-envelope"></i>
                      {{ 'SETTINGS.PASTOR_EMAIL' | translate }}
                    </span>
                    @if (iglesia.pastorEmail) {
                    <a class="church-pastor__contact-value church-pastor__link"
                      [href]="'mailto:' + iglesia.pastorEmail">{{ iglesia.pastorEmail }}</a>
                    } @else {
                    <span class="church-pastor__contact-value church-pastor__empty">—</span>
                    }
                  </li>
                  <li class="church-pastor__contact">
                    <span class="church-pastor__contact-label">
                      <i class="pi pi-phone"></i>
                      {{ 'SETTINGS.PASTOR_PHONE' | translate }}
                    </span>
                    @if (iglesia.pastorPhone) {
                    <a class="church-pastor__contact-value church-pastor__link"
                      [href]="'tel:' + iglesia.pastorPhone">{{ iglesia.pastorPhone }}</a>
                    } @else {
                    <span class="church-pastor__contact-value church-pastor__empty">—</span>
                    }
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        }
      </article>

      <!-- Firma digital -->
      <article class="settings-panel settings-panel--span-7">
        <header class="settings-panel__head">
          <div class="settings-panel__icon settings-panel__icon--accent">
            <i class="pi pi-pencil"></i>
          </div>
          <div class="settings-panel__titles">
            <h2 class="settings-panel__title">{{ 'SETTINGS.DIGITAL_SIGNATURE' | translate }}</h2>
            <p class="settings-panel__desc">{{ 'SETTINGS.SIGN_PAD_HINT' | translate }}</p>
          </div>
        </header>
        <div class="settings-panel__body settings-panel__body--signature">
          @if (showSignaturePad) {
          <app-signature-pad [firmaGuardadaUrl]="firmaGuardadaUrl"></app-signature-pad>
          }
        </div>
      </article>
    </div>

    <!-- Configuración financiera -->
    @if (mostrarCuentasBancarias && iglesia) {
    <article class="settings-panel settings-panel--full">
      <header class="settings-panel__head">
        <div class="settings-panel__icon settings-panel__icon--finance">
          <i class="pi pi-wallet"></i>
        </div>
        <div class="settings-panel__titles">
          <h2 class="settings-panel__title">{{ 'SETTINGS.CONFIGS' | translate }}</h2>
          <p class="settings-panel__desc">{{ 'SETTINGS.MANAGE_BANKS_DESC' | translate }}</p>
        </div>
      </header>

      <div class="settings-panel__body">
        <div class="config-tiles">
          <div class="config-tile" [class.config-tile--active]="iglesia.manejarBancos">
            <div class="config-tile__main">
              <div class="config-tile__icon">
                <i class="pi pi-building-columns"></i>
              </div>
              <div class="config-tile__content">
                <h3 class="config-tile__title">{{ 'SETTINGS.MANAGE_BANKS' | translate }}</h3>
                <p class="config-tile__desc">{{ 'SETTINGS.MANAGE_BANKS_DESC' | translate }}</p>
                @if (hayPeriodoAbierto && !iglesia.manejarBancos) {
                <p-message severity="warn" icon="pi pi-lock"
                  [text]="'SETTINGS.BANKS_LOCKED_PENDING_CLOSE' | translate:{ period: periodoPendienteYM }"
                  class="config-tile__alert" />
                }
              </div>
            </div>
            <div class="config-tile__action">
              @if (!hayPeriodoAbierto || iglesia.manejarBancos) {
              <p-toggleswitch [(ngModel)]="iglesia.manejarBancos" (onChange)="onManejarBancosChange()" />
              } @else {
              <span class="config-tile__locked" title="Bloqueado">
                <i class="pi pi-lock"></i>
              </span>
              }
            </div>
          </div>

          @if (iglesia.manejarBancos) {
          <div class="config-tile config-tile--secondary">
            <div class="config-tile__main">
              <div class="config-tile__icon config-tile__icon--soft">
                <i class="pi pi-credit-card"></i>
              </div>
              <div class="config-tile__content">
                <h3 class="config-tile__title">{{ 'SETTINGS.BANK_ACCOUNTS' | translate }}</h3>
                <p class="config-tile__desc">{{ 'SETTINGS.BANK_ACCOUNTS_DESC' | translate }}</p>
              </div>
            </div>
            <div class="config-tile__action">
              <p-button [label]="'SETTINGS.MANAGE_ACCOUNTS' | translate" icon="pi pi-arrow-right"
                iconPos="right" size="small" (click)="openBankDialog()" />
            </div>
          </div>
          }
        </div>
      </div>
    </article>
    }

    <!-- Auditoría: eliminados -->
    <article class="settings-panel settings-panel--full settings-panel--audit">
      <header class="settings-panel__head">
        <div class="settings-panel__icon settings-panel__icon--audit">
          <i class="pi pi-history"></i>
        </div>
        <div class="settings-panel__titles">
          <h2 class="settings-panel__title">{{ 'DELETED.TITLE' | translate }}</h2>
          <p class="settings-panel__desc">{{ 'DELETED.SUBTITLE' | translate }}</p>
        </div>
      </header>
      <div class="settings-panel__body settings-panel__body--flush">
        <app-eliminados></app-eliminados>
      </div>
    </article>
  </div>

  <!-- Diálogo ministerio -->
  <p-dialog [(visible)]="displayMinistryModal"
    [header]="(isEditingMinistry ? 'SETTINGS.MINISTRY_EDIT_TITLE' : 'SETTINGS.MINISTRY_ADD_TITLE') | translate"
    [modal]="true" [style]="{width: '50vw'}" [resizable]="false" [draggable]="false"
    [breakpoints]="{'960px': '75vw', '640px': '90vw'}">
    <ng-template pTemplate="body">
      <div class="container-fluid px-0">
        <div class="mb-4">
          <p-floatLabel variant="on">
            <input id="nombre" type="text" pInputText [(ngModel)]="currentMinistry.nombre" required autofocus
              class="w-100">
            <label for="nombre">{{ 'SETTINGS.MINISTRY_NAME' | translate }}</label>
          </p-floatLabel>
        </div>

        <div class="d-flex align-items-center mb-4 p-3 bg-light rounded">
          <label for="activo" class="me-3 mb-0 fw-bold">{{ 'SETTINGS.MINISTRY_ACTIVE_STATUS' | translate }}</label>
          <p-toggleswitch id="activo" [(ngModel)]="currentMinistry.activo"></p-toggleswitch>
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold mb-2">{{ 'SETTINGS.MINISTRY_ROLES' | translate }}</label>

          @if (currentMinistry.roles && currentMinistry.roles.length > 0) {
          <div class="d-flex flex-column gap-2">
            @for (role of currentMinistry.roles; track trackByFn($index, role); let i = $index) {
            <div class="input-group">
              <input type="text" pInputText [(ngModel)]="currentMinistry.roles[i]"
                [placeholder]="'SETTINGS.ROLE_NAME_PLACEHOLDER' | translate" required class="form-control">
              <button type="button" pButton pRipple icon="pi pi-times" class="p-button-danger p-button-outlined"
                (click)="removeRoleFromCurrentMinistry(i)"></button>
            </div>
            }
          </div>
          } @else {
          <div class="text-center p-4 bg-light rounded text-muted">
            <i class="pi pi-info-circle mb-2 d-block" style="font-size: 1.5rem"></i>
            {{ 'SETTINGS.MINISTRY_NO_ROLES' | translate }}
          </div>
          }

          <button pButton pRipple [label]="'SETTINGS.MINISTRY_ADD_ROLE' | translate" icon="pi pi-plus"
            class="p-button-secondary p-button-outlined w-100 mt-3" (click)="addRoleToCurrentMinistry()"></button>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <button pButton pRipple [label]="'COMMON.CANCEL' | translate" icon="pi pi-times" class="p-button-text"
        (click)="displayMinistryModal = false"></button>
      <button pButton pRipple [label]="'COMMON.SAVE' | translate" icon="pi pi-check" class="p-button-primary"
        (click)="saveMinistry()"></button>
    </ng-template>
  </p-dialog>
  }

  <!-- Acceso denegado -->
  @if (!isAdminOrPastor) {
  <div class="settings-denied">
    <div class="settings-denied__card">
      <div class="settings-denied__icon">
        <i class="pi pi-shield"></i>
      </div>
      <h2>{{ 'SETTINGS.ACCESS_DENIED' | translate }}</h2>
      <p>{{ 'SETTINGS.ACCESS_DENIED_DESC' | translate }}</p>
    </div>
  </div>
  }

  <!-- Diálogo cuentas bancarias -->
  <p-dialog [header]="'SETTINGS.BANK_ACCOUNTS_MGMT' | translate" [(visible)]="showBankDialog" [modal]="true"
    [style]="{ width: '800px' }" [draggable]="false" [resizable]="false" styleClass="settings-bank-dialog">

    <div class="mb-4">
      <p-button [label]="'SETTINGS.NEW_ACCOUNT' | translate" icon="pi pi-plus" size="small" severity="success"
        (click)="openAddBankAccount()" />
    </div>

    <p-table [value]="cuentasBancarias" styleClass="p-datatable-sm settings-bank-table">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 25%">{{ 'SETTINGS.TABLE_NAME' | translate }}</th>
          <th style="width: 15%">{{ 'SETTINGS.TABLE_TYPE' | translate }}</th>
          <th style="width: 20%">{{ 'SETTINGS.TABLE_BANK' | translate }}</th>
          <th style="width: 10%; text-align:center">{{ 'SETTINGS.TABLE_DEFAULT' | translate }}</th>
          <th style="width: 10%; text-align:center">{{ 'SETTINGS.TABLE_STATUS' | translate }}</th>
          <th style="width: 20%; text-align: center;">{{ 'SETTINGS.TABLE_ACTIONS' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-cuenta>
        <tr>
          <td><strong>{{ cuenta.nombre }}</strong></td>
          <td>
            <span [class]="cuenta.tipo === 'efectivo' ? 'badge bg-success' : 'badge bg-primary'">
              {{ cuenta.tipo === 'efectivo' ? ('SETTINGS.TYPE_CASH' | translate) : ('SETTINGS.TYPE_BANK' | translate) }}
            </span>
          </td>
          <td>{{ cuenta.nombreBanco || '-' }}</td>
          <td style="text-align:center">
            <i [class]="cuenta.esDefault ? 'pi pi-check-circle text-success' : 'pi pi-circle text-secondary'"></i>
          </td>
          <td style="text-align:center">
            <span [class]="cuenta.activo ? 'badge bg-success' : 'badge bg-danger'" style="cursor: pointer;"
              (click)="toggleBankAccount(cuenta)">
              {{ cuenta.activo ? ('SETTINGS.STATUS_ACTIVE' | translate) : ('SETTINGS.STATUS_INACTIVE' | translate) }}
            </span>
          </td>
          <td style="text-align: center;">
            <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" size="small" severity="info"
              (click)="openEditBankAccount(cuenta)" [disabled]="cuenta.id === 'caja-menor'"
              [pTooltip]="cuenta.id === 'caja-menor' ? ('SETTINGS.TOOLTIP_CASH_NO_EDIT' | translate) : ('COMMON.EDIT' | translate)"></p-button>
            <p-button icon="pi pi-trash" [rounded]="true" [text]="true" size="small" severity="danger"
              (click)="deleteBankAccount(cuenta)"
              [disabled]="cuenta.id === 'caja-menor' || cuentasBancarias.length === 1"
              [pTooltip]="cuenta.id === 'caja-menor' ? ('SETTINGS.TOOLTIP_CASH_NO_DELETE' | translate) : (cuentasBancarias.length === 1 ? ('SETTINGS.TOOLTIP_NEED_ONE_ACCOUNT' | translate) : ('COMMON.DELETE' | translate))"></p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center text-muted">{{ 'SETTINGS.EMPTY_ACCOUNTS' | translate }}</td>
        </tr>
      </ng-template>
    </p-table>

    @if (showBankForm) {
    <div class="settings-bank-form card mt-4 p-3">
      <h6 class="mb-3">{{ editingBankAccount ? ('SETTINGS.FORM_EDIT_ACCOUNT' | translate) : ('SETTINGS.FORM_NEW_ACCOUNT' | translate) }}</h6>

      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label fw-bold">{{ 'SETTINGS.FIELD_NAME' | translate }} <span class="text-danger">*</span></label>
          <input pInputText [(ngModel)]="currentBankAccount.nombre" [placeholder]="'SETTINGS.PLACEHOLDER_ACCOUNT_NAME' | translate" class="w-100" />
        </div>

        <div class="col-md-6">
          <label class="form-label fw-bold">{{ 'SETTINGS.FIELD_TYPE' | translate }}</label>
          <p-select [(ngModel)]="currentBankAccount.tipo"
            [options]="[{label: ('SETTINGS.TYPE_CASH' | translate), value: 'efectivo'}, {label: ('SETTINGS.TYPE_BANK' | translate), value: 'banco'}]"
            optionLabel="label" optionValue="value" class="w-100" [style]="{'width':'100%'}"></p-select>
        </div>

        @if (currentBankAccount.tipo === 'banco') {
        <div class="col-md-6">
          <label class="form-label fw-bold">{{ 'SETTINGS.FIELD_BANK_NAME' | translate }} <span
              class="text-muted fw-normal">({{ 'COMMON.OPTIONAL' | translate | lowercase }})</span></label>
          <input pInputText [(ngModel)]="currentBankAccount.nombreBanco" [placeholder]="'SETTINGS.PLACEHOLDER_BANK_NAME' | translate"
            class="w-100" />
        </div>

        <div class="col-md-6">
          <label class="form-label fw-bold">{{ 'SETTINGS.FIELD_ACCOUNT_TYPE' | translate }} <span class="text-muted fw-normal">({{ 'COMMON.OPTIONAL' | translate | lowercase }})</span></label>
          <p-select [(ngModel)]="currentBankAccount.tipoCuenta"
            [options]="[{label: ('SETTINGS.ACCOUNT_TYPE_SAVINGS' | translate), value: 'Ahorro'}, {label: ('SETTINGS.ACCOUNT_TYPE_CURRENT' | translate), value: 'Corriente'}]"
            optionLabel="label" optionValue="value" [placeholder]="'COMMON.SELECT' | translate" class="w-100"
            [style]="{'width':'100%'}"></p-select>
        </div>

        <div class="col-md-6">
          <label class="form-label fw-bold">{{ 'SETTINGS.FIELD_ACCOUNT_NUMBER' | translate }} <span
              class="text-muted fw-normal">({{ 'COMMON.OPTIONAL' | translate | lowercase }})</span></label>
          <input pInputText [(ngModel)]="currentBankAccount.numeroCuenta" [placeholder]="'SETTINGS.PLACEHOLDER_ACCOUNT_NUMBER' | translate"
            class="w-100" />
        </div>

        <div class="col-md-6">
          <label class="form-label fw-bold">{{ 'SETTINGS.FIELD_IBAN' | translate }} <span class="text-muted fw-normal">({{ 'COMMON.OPTIONAL' | translate | lowercase }})</span></label>
          <input pInputText [(ngModel)]="currentBankAccount.iban" [placeholder]="'SETTINGS.PLACEHOLDER_IBAN' | translate"
            class="w-100" />
        </div>

        <div class="col-md-6">
          <label class="form-label fw-bold">{{ 'SETTINGS.FIELD_SWIFT' | translate }} <span class="text-muted fw-normal">({{ 'COMMON.OPTIONAL' | translate | lowercase }})</span></label>
          <input pInputText [(ngModel)]="currentBankAccount.swift" [placeholder]="'SETTINGS.PLACEHOLDER_SWIFT' | translate" class="w-100" />
        </div>
        }

        <div class="col-md-2">
          <label class="form-label fw-bold">{{ 'SETTINGS.FIELD_ORDER' | translate }}</label>
          <p-inputNumber [(ngModel)]="currentBankAccount.orden" [min]="1" [showButtons]="true"
            class="w-100"></p-inputNumber>
        </div>

        <div class="col-md-5 d-flex align-items-center">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="bankEsDefault"
              [(ngModel)]="currentBankAccount.esDefault">
            <label class="form-check-label" for="bankEsDefault">{{ 'SETTINGS.FIELD_DEFAULT_ACCOUNT' | translate }}</label>
          </div>
        </div>

        <div class="col-md-5 d-flex align-items-center">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="bankActivo" [(ngModel)]="currentBankAccount.activo">
            <label class="form-check-label" for="bankActivo">{{ 'SETTINGS.FIELD_ACTIVE' | translate }}</label>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-3">
        <p-button [label]="'COMMON.CANCEL' | translate" severity="secondary" (click)="showBankForm = false" [text]="true"></p-button>
        <p-button [label]="editingBankAccount ? ('COMMON.UPDATE' | translate) : ('COMMON.ADD' | translate)" icon="pi pi-save"
          (click)="saveBankAccount()"></p-button>
      </div>
    </div>
    }

    <ng-template pTemplate="footer">
      <div class="d-flex justify-content-between align-items-center w-100">
        <small class="text-muted">
          <i class="pi pi-info-circle me-1"></i>
          {{ 'SETTINGS.ACCOUNTS_CONFIGURED_COUNT' | translate:{ count: cuentasBancarias.length } }}
        </small>
        <p-button [label]="'SETTINGS.BTN_CLOSE' | translate" icon="pi pi-times" (click)="showBankDialog = false"
          severity="secondary" [text]="true"></p-button>
      </div>
    </ng-template>
  </p-dialog>

  <p-confirmdialog>
    <ng-template #message let-message>
      <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
        <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
        <p>{{ message.message }}</p>
      </div>
    </ng-template>
  </p-confirmdialog>
  <p-toast></p-toast>
</div>
